var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { useWebgate } from "@xvia/webgate-connect";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useCreateTicket } from "../../hooks/useCreateTicket";
import { filesToArquivosDTO, } from "../../services/api/SupportService";
import { ActionButtons } from "./components/ActionButtons";
import { AttachmentSection } from "./components/AttachmentSection";
import { CitizenSection } from "./components/CitizenSection";
import { Header } from "./components/Header";
import { OccurrenceSection } from "./components/OccurrenceSection";
import { SuccessState } from "./components/SuccessState";
import { CATEGORIAS_POR_SISTEMA, formSchema } from "./schema";
import { formatCPF } from "../../utils/FormatCPF";
export default function HomePage() {
    var _this = this;
    var _a = useState(0), charCount = _a[0], setCharCount = _a[1];
    var _b = useState([
        null,
        null,
        null,
    ]), attachments = _b[0], setAttachments = _b[1];
    var _c = useWebgate(), accessToken = _c.accessToken, userInfo = _c.userInfo;
    var mutation = useCreateTicket(accessToken);
    var form = useForm({
        resolver: zodResolver(formSchema),
        defaultValues: {
            fullName: "",
            email: "",
            cpf: "",
            sistema: "",
            categoria: "",
            description: "",
        },
    });
    useEffect(function () {
        if (userInfo) {
            form.setValue("fullName", userInfo.name || "");
            form.setValue("email", userInfo.email || "");
            form.setValue("cpf", formatCPF(userInfo.preferred_username || ""));
        }
    }, [userInfo, form]);
    var watch = form.watch, handleSubmit = form.handleSubmit;
    var descriptionValue = watch("description");
    if (descriptionValue !== undefined && descriptionValue.length !== charCount) {
        setCharCount(descriptionValue.length);
    }
    var onSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var categorias, categoriaSelecionada, selectedFiles, arquivos, ticketData;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    categorias = CATEGORIAS_POR_SISTEMA[data.sistema] || [];
                    categoriaSelecionada = categorias.find(function (cat) { return cat.value === data.categoria; });
                    selectedFiles = attachments.filter(function (file) { return file !== null; });
                    if (!(selectedFiles.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, filesToArquivosDTO(selectedFiles)];
                case 1:
                    arquivos = _c.sent();
                    _c.label = 2;
                case 2:
                    ticketData = __assign({ nome: data.fullName, email: data.email, cpfCnpj: data.cpf.replace(/[^\d]/g, ""), descricao: data.description, categoria: {
                            id: parseInt(data.categoria, 10),
                            sistema: data.sistema,
                            nome: (_a = categoriaSelecionada === null || categoriaSelecionada === void 0 ? void 0 : categoriaSelecionada.label) !== null && _a !== void 0 ? _a : "Sistema",
                            idGLPI: (_b = categoriaSelecionada === null || categoriaSelecionada === void 0 ? void 0 : categoriaSelecionada.idGLPI) !== null && _b !== void 0 ? _b : 0,
                        } }, (arquivos ? { arquivos: arquivos } : {}));
                    mutation.mutate(ticketData);
                    return [2 /*return*/];
            }
        });
    }); };
    if (mutation.isSuccess) {
        var responseData = mutation.data;
        var protocolNumber = (responseData === null || responseData === void 0 ? void 0 : responseData.id) || "0001111100000";
        return (_jsx("div", __assign({ className: "min-h-screen bg-white p-4 md:p-8 font-sans" }, { children: _jsx("div", __assign({ className: "max-w-4xl mx-auto" }, { children: _jsx(SuccessState, { protocolNumber: String(protocolNumber), onBack: function () { return window.location.reload(); } }) })) })));
    }
    return (_jsx("div", __assign({ className: "min-h-screen bg-white p-4 md:p-8 font-sans" }, { children: _jsxs("div", __assign({ className: "max-w-4xl mx-auto space-y-6" }, { children: [_jsx(Header, {}), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit), className: "space-y-6" }, { children: [_jsx(CitizenSection, { form: form }), _jsx(OccurrenceSection, { form: form, charCount: charCount }), _jsx(AttachmentSection, { files: attachments, onChangeFile: function (index, file) {
                                return setAttachments(function (prev) {
                                    var updated = __spreadArray([], prev, true);
                                    updated[index] = file;
                                    return updated;
                                });
                            } }), _jsx(ActionButtons, { onCancel: function () { return window.history.back(); } })] }))] })) })));
}
